import { Box } from "@material-ui/core";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  CcButton,
  CcSkeletonBlock,
  CcTextField,
} from "../../design-system/carecentre";
import { reqDemo } from "../../Stores/Bundles/actions";
import useValidator from "../../utils/useValidator";
import { useStyles } from "./style";

const EmailComponent = ({
  slot,
  date,
  setStep,
  onDateChange,
  setSlot,
  defaultSlot = "1:00 PM - 2:00 PM",
  moduleName,
  resetDate,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isRequestingDemo } = useSelector((state) => state.BundlesReducer);
  const loading = isRequestingDemo;

  const triggerEmail = async (data) => {
    dispatch(
      reqDemo(data, () => {
        clearFormState();
        setStep(1);
        setSlot(defaultSlot);
        onDateChange(
          typeof resetDate === "function"
            ? resetDate()
            : new Date(Date.now() + 86400000),
        );
      }),
    );
  };

  function onSubmit() {
    triggerEmail({
      ...values,
      slot,
      date: moment(date).format("YYYY-MM-DD"),
      module: moduleName,
    });
  }

  const {
    errors,
    touched,
    values,
    handleSubmit,
    setValues,
    clearFormState,
    getFieldProps,
  } = useValidator({
    initialValues: {
      name: "",
      email: "",
      company_name: "",
      mobile: "",
    },
    onSubmit,
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required."),
      company_name: Yup.string().required("Company name is required."),
      mobile: Yup.string()
        .test(
          "Contact Number format",
          "Invalid contact number format",
          function (value) {
            const mobileRegex =
              /^((\+44(\s\(0\)\s|\s0\s|\s)?)|0)?\d{4}(\s)?\d{6}$/;
            return (
              typeof value === "string" &&
              mobileRegex.test(value.replace(/\s/g, ""))
            );
          },
        )
        .required("Contact number is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
    }),
  });

  useEffect(() => {
    clearFormState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={classes.stepBody}>
      <div>
        <h2 className={classes.sectionTitle}>Your details</h2>
        <p className={classes.sectionSub}>
          Demo invite for {moment(date).format("D MMM YYYY")} · {slot}
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        {loading ? (
          <CcSkeletonBlock lines={4} />
        ) : (
          <Box className={classes.fieldStack}>
            <Box className={classes.fieldRow}>
              <CcTextField
                label="Name"
                placeholder="Your name"
                value={values.name}
                helperText={touched.name && errors.name}
                error={!!(touched.name && errors.name)}
                onChange={(e) =>
                  setValues({
                    ...values,
                    name: e.target.value,
                  })
                }
              />
              <CcTextField
                label="Email"
                placeholder="you@carehome.com"
                value={values.email}
                helperText={touched.email && errors.email}
                error={!!(touched.email && errors.email)}
                {...getFieldProps("email")}
              />
            </Box>
            <Box className={classes.fieldRow}>
              <CcTextField
                label="Contact number"
                placeholder="UK number"
                value={values.mobile}
                helperText={touched.mobile && errors.mobile}
                error={!!(touched.mobile && errors.mobile)}
                {...getFieldProps("mobile")}
              />
              <CcTextField
                label="Company name"
                placeholder="Care home or group"
                value={values.company_name}
                helperText={touched.company_name && errors.company_name}
                error={!!(touched.company_name && errors.company_name)}
                onChange={(e) =>
                  setValues({
                    ...values,
                    company_name: e.target.value,
                  })
                }
              />
            </Box>
          </Box>
        )}
        <Box className={classes.formActions}>
          <button
            type="button"
            className={classes.backLink}
            onClick={() => setStep(2)}
            disabled={loading}
          >
            Back
          </button>
          <CcButton
            type="submit"
            variant="primary"
            size="sm"
            disabled={isRequestingDemo}
          >
            Request demo
          </CcButton>
        </Box>
      </form>
    </Box>
  );
};

export default EmailComponent;
